// extracted by mini-css-extract-plugin
export default {"Container":"Switch_Container__sMGO9","Main":"Switch_Main__dMvPz","Options":"Switch_Options__FHmAf","Option":"Switch_Option__KmuBQ"};